import { useEffect, useRef } from 'react'

/**
 * Runs the latest `handler` on `beforeunload`. If the handler cancels the
 * event, `returnValue` is also set so older Chromium shows the leave prompt.
 */
export const useBeforeunload = (
  handler: (event: BeforeUnloadEvent) => void,
) => {
  const handlerRef = useRef(handler)

  useEffect(() => {
    handlerRef.current = handler
  })

  useEffect(() => {
    const listener = (event: BeforeUnloadEvent) => {
      handlerRef.current(event)
      if (event.defaultPrevented) {
        event.returnValue = true
      }
    }
    window.addEventListener('beforeunload', listener)
    return () => window.removeEventListener('beforeunload', listener)
  }, [])
}
